<template>
  <div class="home" @click="isDo()">
    <div class="homeleft">
      <div class="homeleftt">
        <div class="homeleftti"><img style="width: 100%;height: 100%;" src="../assets/zhuhahome.png"> </div>
        <div class="homeleftts">
          助花总服务台
        </div>
      </div>

      <div class="feature" v-for="(item, index) in admins">
        <div class="features">
          <div class="featurest" :id="'featurest' + index" @click="goyun(item)"
            :class="bgc == item.permName ? 'bgc' : ''" :key="index">

            <div style="margin-right: 10px;height: 24px;">
              <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="guanli"
                v-if="item.permId == 'c531d0d05dc4d81dbf916d5a349f0941'"></SvgIcon>
              <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="vip"
                v-if="item.permId == 'c2080741ecfe5d1c9edf831a57144a75'"></SvgIcon>
              <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="store"
                v-if="item.permId == 'c8b3636ccb6cbb813b5a31f248fe8088'"></SvgIcon>
              <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="dinbgdan"
                v-if="item.permId == 'a901efae1759051f012ebcb528f0eb2a'"></SvgIcon>
              <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="huodong"
                v-if="item.permId == '161fcbf5b1ec0321610fc334a39c749f'"></SvgIcon>
              <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="moban"
                v-if="item.permId == '246e888b686bda15760faceb1c484706'"></SvgIcon>
              <!-- <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="goody"
                v-if="item.permId == '611c25c2e7dde3110837f48711d86793'"></SvgIcon> -->
                <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="zhijing" 
                v-if="item.permId == '611c25c2e7dde3110837f48711d86793'"></SvgIcon>
                <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="goody" 
                v-if="item.permId == '44bca9dd232a13077d93874bb1cae28a'"></SvgIcon>
                <SvgIcon class="svg-icon" :class="bgc == item.permName ? 'bgc' : ''" iconClass="fenxaio" 
                v-if="item.permId == 'ff5067c5c99280b81e2d2686e9c98312'"></SvgIcon>

                
            </div>
            <div> {{ permName(item.permName) }} &nbsp;&nbsp; <span
                v-show="item.permId == '161fcbf5b1ec0321610fc334a39c749f' || item.permId == 'c531d0d05dc4d81dbf916d5a349f0941'"><el-icon>
                  <ArrowDown />
                </el-icon></span>
              </div>
           

          </div>
          <div class="featuresd2" v-if="item.permId == 'c531d0d05dc4d81dbf916d5a349f0941'">
            <div class="featuress" :class="changis == 1 ? 'getcolor' : ''" @click="goodlistgo">商品列表管理</div>
            <div class="featuress" :class="changis == 2 ? 'getcolor' : ''" @click="guogego">规格模板管理</div>
            <div class="featuress" :class="changis == 5 ? 'getcolor' : ''" @click="pingpai">商品品牌管理</div>
          </div>
          <div class="featuresd" v-if="item.permId == '161fcbf5b1ec0321610fc334a39c749f'">
            <div class="featuress" :class="changis == 3 ? 'getcolor' : ''" @click="chang">运营场次管理</div>
            <div class="featuress" :class="changis == 4 ? 'getcolor' : ''" @click="goods">运营商品管理</div>
          </div>
        </div>
      </div>
      <div style="height: 150px;"></div>
      <div class="homeleftd">
        <div class="homeleftds" @click="gointall" :class="bgc == 'intall' ? 'bgc' : ''">

          <div class="hiocn"><el-icon :size="20">
              <Setting />
            </el-icon></div>

          <div>设置</div>
        </div>
        <div class="homeleftds" @click="logout">

          <div class="hiocn">
            <img style="width: 24px;height: 24px;" src="../assets/itex.png" alt="">
          </div>
          <div>退出登录</div>
        </div>
      </div>
    </div>
    <div class="homeright">
      <div class="homerightt">
        <div class="search">
          <!-- <div style="width: 24px;height: 24px;margin-right: 14px;text-align: center;">
            <el-icon size="24">
              <Search />
            </el-icon>
          </div>
          <div>
            <input type="text" placeholder="全站搜索" v-model="keyseach" @keyup.enter="wordkey">
          </div> -->
        </div>
        <div class="storename">
          <div class="tis" @click="openDialog">
            <img style="width: 24px;height: 24px;" src="../assets/lingdan.png" alt="">
            <div v-if="msg" class="xiaoxi"></div>
          </div>
          <div class="stroeh">
            <div class="userh">
              <!-- <img src="../assets/shop/morentx.png" alt=""> -->
              <!-- <SvgIcon class="svg-icon" iconClass="man3"></SvgIcon> -->
              <img :src='roleAvatar'>
            </div>
            <div class="username">
              {{ username }}
            </div>
          </div>
        </div>
      </div>
      <div class="homerightd">
        <router-view> </router-view>
      </div>
    </div>
  </div>
  <yc-mask ref="maskRef" :close-on-click-modal="true">
    <div class="dialog">
      <div class="top">通知</div>
      <div class="flexed">

        <div @click="flei1" :class="fleis == 1 ? 'leion' : 'leis'">
          <div>普通订单</div>
          <div class="news">{{ messageleng[0] > 99 ? '99+' : messageleng[0] }}</div>
        </div>
        <div :class="fleis == 2 ? 'leion' : 'leis'" @click="flei2">
          <div>积分订单</div>
          <div class="news">{{ messageleng[1] > 99 ? '99+' : messageleng[1] }}</div>
        </div>
        <div :class="fleis == 3 ? 'leion' : 'leis'" @click="flei3">
          <div>活动相关</div>
          <div class="news">{{ messageleng[2] > 99 ? '99+' : messageleng[2] }}</div>
        </div>
      </div>
      <div class="contents">
        <div class="contente">
          <div class="content" v-for="item in pagemessage">
            <div class="images">
              <img :src="images(item.msgExtraDataJson.productImg)" alt="">
            </div>
            <div class="messages">
              <div class="details">
                <div v-html="parseHTML(item.msgContent)"></div>
                <!-- 贾剑峰632 刚刚在 hexx店铺 下了一个新订单，共计 ￥19.00 -->
              </div>
              <div class="ontime">
                {{ msgtime(item.msgDataLastTime) }}
              </div>
            </div>
          </div>

        </div>
        <!-- <div v-if="fleis == 2">2</div>
        <div v-if="fleis == 3">3</div> -->
      </div>
      <div class="alldet">
        <div style="cursor: pointer;" @click="yidu">全部标记为已读</div>
        <div style="cursor: pointer;" @click="lookmesg">查看全部通知</div>
      </div>
    </div>
  </yc-mask>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import api from '@/api/api';
import storeapi from '@/api/store';
import { ElMessage, ElMessageBox } from 'element-plus'
import bus from '@/utils/bus'
const msg = ref(false)
bus.on('sendMsg', (data) => {
  msg.value = data
  console.log('msg.value', msg.value)
})
const router = useRouter();
const keyseach = ref('')
const store = useStore();
const username = ref('')

const state = reactive({
  homebgcValue: store.state.homebgc
});
let roleAvatar = ref('')

const getroleAvatar = () => {
  let roleAvatarList = [
    "http://120.31.134.56:7878/images/roleAvatar/man1.svg",
    "http://120.31.134.56:7878/images/roleAvatar/man2.svg",
    "http://120.31.134.56:7878/images/roleAvatar/man3.svg",
    "http://120.31.134.56:7878/images/roleAvatar/man4.svg"
  ]; // 图片url数组

  let roleId = JSON.parse(localStorage.getItem('usermassage')).adminRoleList[0].roleId
  let roleId2Number = roleId.replace(/[^0-9]/ig, ""); // 提取数字部分

  // 计算索引位置并获取对应的头像URL
  let index = parseInt(roleId2Number) % roleAvatarList.length;
  roleAvatar.value = roleAvatarList[index];

  console.log(roleAvatar); // 打印获取到的头像URL
}
let itemRefs = [];
const setItemRefs = (el, item) => {
  if (el) {
    itemRefs.push({
      id: item,
      el,
    });
  }
  refchange()


}
const refchange = () => {
  // itemRefs[0].el.innerHTML = '111' 
}
let changis = ref(null)
const goodlistgo = () => {
  changis.value = 1
  router.push('/home/goodlist')
}
const guogego = () => {
  changis.value = 2
  router.push('/home/standard')

}
const pingpai = () =>{
  router.push('/home/goodlist/PinList')

  changis.value = 5
}
const chang = () => {
  changis.value = 3
  router.push('/home/events/chang')
}
const goods = () => {
  changis.value = 4
  router.push('/home/events/goods')
}
onMounted(() => {
  qunxain()
  lastTime.value = new Date().getTime();//网页第一次打开时，记录当前时间
  console.log('网页第一次打开时，记录当前时间', lastTime.value)
  let usermassage = localStorage.getItem('user')
  relogin.value = sessionStorage.getItem('relogin')
  getroleAvatar()
  console.log(JSON.parse(usermassage))
  username.value = JSON.parse(usermassage).userName
  console.log(state)
  bgc.value = state.homebgcValue
  console.log('itemRefs', itemRefs);
  havemess.value = messageleng.value.slice(0, 3) != '0';
  console.log('havemess', havemess.value);

})
let admins = ref()
const qunxain = () => {
  let adminPermList
  let adminPermLists
  let admin
  if (localStorage.getItem('usermassage') && JSON.parse(localStorage.getItem('usermassage')).adminPermList != null) {
    adminPermList = JSON.parse(localStorage.getItem('usermassage'))
    adminPermLists = adminPermList.adminPermList
    console.log('adminPermList', adminPermLists)
    admin = adminPermLists.filter(item => item.permPathLevel == 1 && item.permName != "管理账号" && item.permName != "后台设置" && item.permName != "规格模板")
    console.log('qunxain', admin)
    admins.value = admin
  }
}

const bgc = ref('')
const logout = async () => {
  const res = await api.logout()
  if (res.success) {
    localStorage.removeItem('token')
    localStorage.removeItem('vuex-along')
    localStorage.removeItem('usermassage')
    router.push('/login')
  }
}
let lastTime = ref(null)//最后一次点击的时间
let currentTime = ref(null)//当前点击的时间
let timeOut = ref(30 * 60 * 1000)//设置超时时间
let relogin = ref(null)
const isDo = () => {
  console.log('yonghu', relogin.value)
  currentTime.value = new Date().getTime(); //记录这次点击的时间
  if (currentTime.value - lastTime.value > timeOut.value || relogin.value == 'false') {  //判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
    // 这里写状态已过期后执行的操作
    // console.log('长时间未操作')
    ElMessageBox.alert('长时间未操作请重新登入！', '', {
      confirmButtonText: 'OK',
      callback: (action) => {
        sessionStorage.setItem('relogin', false)
        router.push({
          path: '/login'
        })
      }
    })
  } else {
    lastTime.value = new Date().getTime(); //如果在10分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间

  }
}
const permName = (name) => {
  if (name == '商品权限') {
    return '商品管理'
  } else if (name == '店铺') {
    return '商铺管理'
  } else if (name == '会员管理') {
    return '会员管理'
  } else if (name == '订单权限') {
    return '助花订单'
  } else if (name == '活动运营管理') {
    return '运营管理'
  } else if (name == '运费模板') {
    return '运费模板'
  } else if (name == '规格模板') {
    return '规格模板'
  } else if (name == '资金管理') {
    return '资金管理'
  }
  else if (name == '礼包管理') {
    return '会员礼包'
  }
  else if (name == '分销码') {
    return '分销详情'
  }
}


const yidu = async () => {
  let userId = JSON.parse(localStorage.getItem('user')).userId
  console.log(userId)
  let data = {
    userId: userId,
    isReadAll: true
  }
  const res = await storeapi.markOverRead(data)
  console.log('11111', res)

  if (res.success) {
    console.log('22222')
    ElMessage({
      message: '全部已读',
      type: 'success',
      onClose: () => {

      }
    })
    pagemessage.value = []
    messageleng.value = [0, 0, 0]
    let message = {
      orderMsg: [],
      integralOrderMsg: [],
      seckillActivityMsg: [],
    }
    localStorage.setItem('message', JSON.stringify(message))

  }
}
const lookmesg = () => {
  maskRef.value.closeMask();
  router.push('/home/message')
}
const gointall = () => {
  bgc.value = 'intall'
  store.commit('sethomebgc', 'intall');
  store.commit('setinstallbgc', 'rizsr1');
  router.push('/home/install/installData')
}
// const gogoods = () => {
//   bgc.value = 'gogoods'
//   store.commit('sethomebgc', 'gogoods');
//   router.push('/home/goodlist')
// }
// const govip = () => {
//   bgc.value = 'viplist'
//   store.commit('sethomebgc', 'viplist');
//   router.push('/home/viplist')
//   console.log(bgc.value)
// }
// const goorder = () => {
//   bgc.value = 'orderlist'
//   store.commit('sethomebgc', 'orderlist');

//   router.push('/home/orderlist')
//   console.log(bgc.value)
// }
// const goshop = () => {
//   bgc.value = 'shop'
//   store.commit('sethomebgc', 'shop');
//   router.push('/home/shop')
//   console.log(bgc.value)
// }

let isyun = true
let stopyun = true
const goyun = (item) => {
  store.commit('sethomebgc', item.permName);
  console.log('sethomebgc', item.permName)
  const featuresdElements = document.querySelector('.featuresd');
  const featuresdElements2 = document.querySelector('.featuresd2');

  if (item.permId == '161fcbf5b1ec0321610fc334a39c749f') {
    bgc.value = item.permName
    if (isyun) {
      isyun = false
      // console.log('featuresdElements', featuresdElements)
      featuresdElements.classList.add('expanded');
      console.log(item)
    } else {
      isyun = true
      featuresdElements.classList.remove('expanded');
    }
  } else if (item.permId == 'c531d0d05dc4d81dbf916d5a349f0941') {
    bgc.value = item.permName
    if (stopyun) {
      stopyun = false
      // console.log('featuresdElements', featuresdElements)
      featuresdElements2.classList.add('expanded');
      console.log(item)
    } else {
      stopyun = true
      featuresdElements2.classList.remove('expanded');
    }
  }
  else {
    isyun = true
    stopyun = true
    featuresdElements.classList.remove('expanded');
    bgc.value = item.permName
    router.push(item.permPath)
    console.log(bgc.value)
  }

}
import ycMask from '@/components/mask/homemask.vue'
let fleis = ref(1)
const flei1 = () => {
  fleis.value = 1
  pageMsgs(1)
}
const flei2 = () => {
  fleis.value = 2
  pageMsgs(2)
}
const flei3 = () => {
  fleis.value = 3
  pageMsgs(3)

}
let havemess = ref(true)
let messageleng = ref([])
//关闭弹窗
let closeDialog = () => {
  maskRef.value.closeMask();
};
//获取遮罩的实例
let maskRef = ref(null);
//导出的遮罩层
let openDialog = async () => {

  let megs = JSON.parse(localStorage.getItem('message'))
  messageleng.value = [megs.orderMsg.length, megs.integralOrderMsg.length, megs.seckillActivityMsg.length]

  pageMsgs(1)

  maskRef.value.showMask();
};

let pagemessage = ref([])
const pageMsgs = async (overReadStatus) => {
  let orderMsg = []
  if (overReadStatus == 1) {
    orderMsg = JSON.parse(localStorage.getItem('message')).orderMsg
  }
  if (overReadStatus == 2) {
    orderMsg = JSON.parse(localStorage.getItem('message')).integralOrderMsg
  }
  if (overReadStatus == 3) {
    orderMsg = JSON.parse(localStorage.getItem('message')).seckillActivityMsg
  }
  pagemessage.value = orderMsg
  for (let a = 0; a < pagemessage.value.length; a++) {
    pagemessage.value[a].msgExtraDataJson = JSON.parse(pagemessage.value[a].msgExtraDataJson)
  }
  console.log('pagemessage', pagemessage.value)
}
function parseHTML(html) {
  // 创建一个临时 div 元素
  const tempDiv = document.createElement('div');
  // 将 HTML 字符串赋值给临时 div 的 innerHTML
  tempDiv.innerHTML = html;
  // 返回解析后的内容
  return tempDiv.innerHTML;
}
function msgtime(time) {
  return time.replace('T', ' ');
}
const images = (face) => {

  if (face) {
    const regex = /"(.*?)"/;
    const result = face.match(regex);
    // 输出提取的字符
    if (result && result[1]) {
      if (result[1].startsWith('http')) {
        return result[1]
      } else {
        if (result[1].startsWith('/')) {
          return 'http://www.daomenkou.cn' + result[1]

        } else {
          return 'http://www.daomenkou.cn/' + result[1]

        }
      }
    } else {
      console.log('未找到匹配的字符串');

      if (face.startsWith('http')) {
        return face
      } else {
        return 'http://www.daomenkou.cn/' + face
      }
    }
  } else {
    return require('../assets/shop/morentx.png')
  }

}
</script>

<style lang="scss" scoped>
.dialog {
  position: absolute;
  // right: 0px;

  width: 439px;
  height: 628px;
  background: #FFFFFF;
  box-shadow: 13px 15px 50px 0px rgba(0, 0, 0, 0.5), 10px 15px 1px 0px rgba(113, 128, 150, 0.08);
  border-radius: 8px;

  .top {
    padding: 24px 0 0 24px;
    box-sizing: border-box;
  }

  .flexed {
    padding: 32px 0 0 24px;
    display: flex;

    div:first-child {
      margin-left: 0px;
    }

    .leis {

      display: flex;
      font-size: 14px;
      color: #718096;
      margin-left: 24px;
      cursor: pointer;

      .news {
        width: 20px;
        height: 20px;
        background: #EEEFF2;
        box-shadow: 13px 15px 50px 0px rgba(0, 0, 0, 0.5);
        border-radius: 10px;
        text-align: center;
        line-height: 20px;
        font-size: 10px;
        margin-left: 8px;
      }

    }

    .leion {
      display: flex;
      font-size: 14px;
      color: #3F8CFF;
      margin-left: 24px;
      cursor: pointer;

      .news {
        width: 20px;
        height: 20px;
        background: #E3EEFF;
        box-shadow: 13px 15px 50px 0px rgba(0, 0, 0, 0.5);
        border-radius: 10px;
        text-align: center;
        line-height: 20px;
        font-size: 10px;
        margin-left: 8px;
      }
    }


  }

  .contents {
    margin-top: 16px;

    .contente {
      overflow: auto;
      height: 430px;

      .content {
        width: 100%;
        height: 96px;
        background: #F9FAFB;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #EEEFF2;

        .images {
          width: 48px;
          height: 48px;
          border-radius: 24px;

          background: #3F8CFF;
          margin: 0 20px 0 27px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .messages {
          width: 309px;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          color: #111827;

          .details {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .ontime {
            font-size: 12px;
            color: #A0AEC0;
          }
        }
      }
    }


  }

  .alldet {
    width: 100%;
    height: 80px;
    display: flex;
    padding: 0 24px;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    font-size: 14px;
    // font-family: AppleSystemUIFont;
    color: #3F8CFF;
    position: absolute;
    bottom: 0px;
    left: 0px;

  }

  // position: relative;
}

.home {
  // height: 100vh;
  min-height: 939px;
  min-width: 1280px;
  padding: 17px 32px 58px 20px;
  box-sizing: border-box;
  background-color: #F2F8FC;
  display: flex;

  .bgc {
    background: #DAEFFF;
    color: #0091FF !important;
    font-weight: 500;
  }

  .homeleft {

    width: 200px;
    // height: 100%;
    padding-top: 23px;
    background-color: #FFFFFF;
    border-radius: 16px;
    margin-right: 22px;
    position: relative;

    .homeleftt {
      width: 100%;
      height: 97px;
      display: flex;
      align-items: center;

      .homeleftti {
        margin: 0 12px 0 18px;
        width: 40px;
        height: 40px;
        // background-color: #D4D4D4;
        border-radius: 8px;
      }

      .homeleftts {
        font-size: 18px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.88);
      }
    }

    .features {
      // line-height: 42px;
      // height: 42px;
      color: #718096;

      margin-bottom: 10px;

      .featurest {
        padding-left: 28px;
        box-sizing: border-box;
        height: 42px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: color 0.5s, background-color 0.5s;

      }

      .featurest:hover {
        background-color: #DAEFFF;
        color: #0091FF;
      }

      .featuresd {
        height: 0;
        overflow: hidden;

        transition: height 0.5s;

        // background-color: #c42323;

        .featuress {
          height: 40px;
          background-color: #fff;
          padding-left: 60px;
          line-height: 40px;
          box-sizing: border-box;
          cursor: pointer;



        }

        .getcolor {
          background-color: #f3faff;
          color: rgb(0, 145, 255);
        }

      }

      .featuresd2 {
        height: 0;
        overflow: hidden;

        transition: height 0.5s;

        // background-color: #c42323;

        .featuress {
          height: 40px;
          background-color: #fff;
          padding-left: 60px;

          line-height: 40px;
          box-sizing: border-box;
          cursor: pointer;




        }

        .getcolor {
          background-color: #f3faff;
          color: rgb(0, 145, 255);
        }
      }


      .featuresd.expanded {
        // display: block;
        height: 80px;
      }

      .featuresd2.expanded {
        // display: block;
        height: 120px;
      }

    }



    .homeleftd {
      width: 100%;
      box-sizing: border-box;
      font-size: 16px;
      position: absolute;
      bottom: 30px;

      .homeleftds {
        color: #718096 !important;
        display: flex;
        align-items: center;
        height: 48px;
        margin-bottom: 20px;
        padding-left: 27px;

        .hiocn {
          width: 24px;

          margin-right: 16px;

        }
      }
    }
  }

  .homeright {

    // height: 100%;

    width: calc(100% - 222px);

    .homerightt {

      height: 85px;
      display: flex;
      justify-content: space-between;

      .search {
        width: 412px;
        height: 52px;
        // background: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0px 3px 29px 0px rgba(196, 203, 214, 0.1);
        padding-left: 19px;
        display: flex;
        align-items: center;

        input {
          width: 300px;
          border: none;
          outline: none;
          font-size: 16px;
        }
      }

      .storename {
        display: flex;

        .tis {
          width: 52px;
          height: 52px;
          background: #FFFFFF;
          box-shadow: 0px 3px 29px 0px rgba(196, 203, 214, 0.1);
          margin-right: 24px;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .xiaoxi {
            position: absolute;
            top: 35px;
            left: 30px;
            width: 6px;
            height: 6px;
            border-radius: 3px;
            background-color: red;
          }
        }

        .stroeh {
          width: 181px;
          height: 52px;
          border-radius: 26px;
          background: #FFFFFF;
          box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
          display: flex;
          align-items: center;
          padding-left: 7px;
          box-sizing: border-box;

          .userh {
            width: 44px;
            height: 44px;
            border-radius: 22px;
            margin-right: 7px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .username {
            font-size: 16px;
            font-weight: 400;
            color: #0A1629;
          }
        }
      }
    }

    .homerightd {
      // margin-top: 20px;
      height: calc(100% - 70px);
      border: 1px solid transparent;
      box-sizing: border-box;

    }
  }
}
</style>